import React from 'react';
import classnames from 'classnames';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import LegacyButton from '../LegacyButton';
import IconOnlyButton from '../IconOnlyButton';
import ModalDialog from '../feedback/ModalDialog';
import { EllipsisIcon } from '../LegacyIcons';

class DropdownButton extends React.Component {
  static defaultProps = {
    showDropdown: false,
    onToggleDropdown: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      showDropdown: props.showDropdown || false,
    };
    this.toggleDropdown = this.toggleDropdown.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.showDropdown !== nextProps.showDropdown) {
      this.setState(() => ({ showDropdown: nextProps.showDropdown }));
    }
  }

  toggleDropdown() {
    this.setState(
      prevState => ({ showDropdown: !prevState.showDropdown }),
      () => {
        const { onToggleDropdown } = this.props;
        const { showDropdown } = this.state;
        if (onToggleDropdown) {
          onToggleDropdown({ showDropdown });
        }
      }
    );
  }

  render() {
    const { showDropdown } = this.state;
    const { children, dropdown, onClick } = this.props;
    const toggleClasses = classnames({
      'c-button-dropdown__toggle': !!children,
    });

    return (
      <div className="c-button-dropdown">
        {children && (
          <LegacyButton theme="primary" sharp="right" onClick={onClick}>
            {children}
          </LegacyButton>
        )}
        <span className={toggleClasses}>
          <IconOnlyButton primary onClick={this.toggleDropdown}>
            <span>
              <span className="u-hide-visually">More actions</span>
              <EllipsisIcon size="x-large" />
            </span>
          </IconOnlyButton>
        </span>
        <ReactCSSTransitionGroup
          transitionName="c-button-dropdown__modal-dialog"
          transitionEnterTimeout={200}
          transitionLeaveTimeout={200}
        >
          {showDropdown && (
            <span className="c-button-dropdown__modal-dialog">
              <ModalDialog onClose={this.toggleDropdown}>
                {dropdown}
              </ModalDialog>
            </span>
          )}
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}

export default DropdownButton;
